import {Injectable} from '@angular/core';

/**
 * Solution provided by stackoverflow
 * https://stackoverflow.com/questions/34177221/angular2-how-to-inject-window-into-an-angular2-service
 */

function getWindow() {
  return window;
}

@Injectable({
  providedIn: 'root',
})
export class BdWindowRefService {
  public get(): Window {
    return getWindow();
  }
}
